import { useEffect, useRef } from "react";

function BlikCodeInput({
  autoFocus = false,
  error,
  hint = "Potwierdzisz w aplikacji banku",
  id = "blik-code",
  label = "Kod BLIK",
  onChange,
  value = "",
}) {
  const digitInputs = useRef([]);

  useEffect(() => {
    if (autoFocus) digitInputs.current[0]?.focus();
  }, [autoFocus]);

  function updateCode(index, rawValue) {
    const digits = rawValue.replace(/\D/g, "");
    const next = (value + "      ").slice(0, 6).split("");

    if (digits.length > 1) {
      digits
        .slice(0, 6 - index)
        .split("")
        .forEach((digit, offset) => {
          next[index + offset] = digit;
        });
    } else {
      next[index] = digits;
    }

    onChange(next.join("").trimEnd());

    if (digits) {
      digitInputs.current[Math.min(index + digits.length, 5)]?.focus();
    }
  }

  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;

  return (
    <div
      className={`checkout-blik-panel${
        error ? " checkout-blik-panel--invalid" : ""
      }`}
    >
      <div className="checkout-blik-panel__heading">
        <label className="checkout-blik-panel__label" htmlFor={id}>
          {label}
        </label>
        {hint && (
          <small id={hintId} className="checkout-blik-panel__hint">
            {hint}
          </small>
        )}
      </div>
      <div className="checkout-blik-panel__code">
        <div
          className="checkout-blik-panel__digits"
          role="group"
          aria-label="Sześciocyfrowy kod BLIK"
        >
          {Array.from({ length: 6 }, (_, index) => (
            <input
              key={index}
              id={index === 0 ? id : undefined}
              ref={(element) => {
                digitInputs.current[index] = element;
              }}
              type="text"
              inputMode="numeric"
              autoComplete={index === 0 ? "one-time-code" : "off"}
              maxLength={1}
              aria-label={`Cyfra ${index + 1} kodu BLIK`}
              aria-describedby={
                index === 0
                  ? error
                    ? errorId
                    : hint
                    ? hintId
                    : undefined
                  : undefined
              }
              aria-invalid={Boolean(error)}
              value={value[index] || ""}
              onChange={(event) => updateCode(index, event.target.value)}
              onPaste={(event) => {
                event.preventDefault();
                updateCode(index, event.clipboardData.getData("text"));
              }}
              onKeyDown={(event) => {
                if (event.key === "Backspace" && !value[index] && index > 0) {
                  updateCode(index - 1, "");
                  digitInputs.current[index - 1]?.focus();
                } else if (event.key === "ArrowLeft" && index > 0) {
                  digitInputs.current[index - 1]?.focus();
                } else if (event.key === "ArrowRight" && index < 5) {
                  digitInputs.current[index + 1]?.focus();
                }
              }}
            />
          ))}
        </div>
      </div>
      {error && (
        <small id={errorId} className="checkout-blik-panel__error">
          {error}
        </small>
      )}
    </div>
  );
}

export default BlikCodeInput;
